import {singleton} from "tsyringe";
import {container} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";
import {OpenNewDailyDialogCommand} from "../open-new-daily-dialog.command";
import {ProjectRepository} from "../../domain/repositories/project.repository";
import {DialogHelper} from "../../helpers/dialog.helper";
import {get} from "lit-translate";
import {BOARD_TYPE_DAILY} from "../../constants";

@CommandHandler(OpenNewDailyDialogCommand)
@singleton()
export class OpenNewDailyDialogCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        const projectRepository = container.resolve(ProjectRepository);
        const daily = await projectRepository.create(BOARD_TYPE_DAILY);
        const title = get(`ha-boards-view.add-entity.add-daily`);
        const closable = true;
        
        DialogHelper.showDialog(`ha-dialog-daily-edit`, {title, daily, closable});
    }
}